export default "__VITE_ASSET__3d8583d5__"